import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

/** 認証必須ルートのガード。未認証なら /login にリダイレクト。 */
export default function AuthGate() {
  const credentials = useAuthStore((s) => s.credentials);
  const location = useLocation();
  if (!credentials) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
